import { Image } from 'lucide-react';
import { cn } from '@/helpers/shadcn';
import { Skeleton } from '@/components/ui/skeleton';

interface ImageWithFallbackProps {
  src?: string;
  alt: string;
  className?: string;
  placeholderClassName?: string;
  loading?: boolean;
}

export function ImageWithFallback({
  src,
  alt,
  className = '',
  placeholderClassName = '',
  loading = false,
}: ImageWithFallbackProps) {
  if (loading) {
    return (
      <Skeleton
        className={cn(
          'h-full w-full rounded-lg bg-stone-200',
          placeholderClassName
        )}
      >
        <div className="flex h-full w-full items-center justify-center">
          <Image className="h-12 w-12 animate-pulse text-stone-400" />
        </div>
      </Skeleton>
    );
  }

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn('h-full w-full rounded-lg object-cover', className)}
      />
    );
  }

  return (
    <div
      className={cn(
        'flex h-full w-full items-center justify-center rounded-lg bg-stone-100',
        placeholderClassName
      )}
    >
      <Image className="h-12 w-12 text-stone-400" />
    </div>
  );
}
